import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class CloseRequestPayload extends RequestPayload {
}
